const resizeManager = {
  init(canvas, lib, desktop) {
    this.flag = true;

    this.desktop = desktop;
    this.canvas = canvas;
    this.body = document.querySelector('body');
    this.canvasWrap = document.querySelector('#game-canvas-wrap');
    this.mobileSafariOverlay = document.querySelector('#mobile-safari-overlay');

    if (this.desktop) {
      this.guiDesktop = document.querySelector('#gui-desktop');
      this.body.classList.add('desktop');
      this.guiDesktopWidth = this.guiDesktop.offsetWidth;
      this.guiDesktopHeight = this.guiDesktop.offsetHeight;
    }

    this.setBounds(lib);
    this.bindResize();
    this.preventDoubleTap();

    this.mobileSafari = ['iPhone', 'Safari'].every(el => window.navigator.userAgent.includes(el));

    if (this.mobileSafari) {
      this.enableSafariFullscreen();
    } else {
      this.enableFullscreen();
    }
  },

  tick() {
    if (!this.flag) {
      return;
    }
    this.flag = false;

    this.setOrientation();
    this.setCanvasHeight();

    if (this.mobileSafari) {
      this.mobileSafariTick();
    }
  },

  mobileSafariTick() {
    this.minimalUI = window.innerHeight >= this.body.clientHeight;
    this.mobileSafariOverlay.hidden = this.minimalUI;
    createjs.Ticker.paused = !this.minimalUI;
    window.scroll(0, 0);

    // инача после смены ориентации считает высоту по старой, похоже изза position: fixed
    setTimeout(() => this.setCanvasHeight(), 500);
  },

  setBounds(lib) {
    this.canvas.width = lib.properties.width;
    this.canvas.height = lib.properties.height;
    this.aspectRatio = lib.properties.width / lib.properties.height;
  },

  setOrientation() {
    if (this.desktop) {
      return;
    }

    this.body.classList[this.body.offsetWidth > this.body.offsetHeight ? 'remove' : 'add']('vertical');
  },

  setCanvasHeight() {
    const availableWidth = this.canvasWrap.offsetWidth;
    let availableHeight = this.canvasWrap.offsetHeight;

    if (this.desktop) {
      const guiDesktopScale = availableWidth >= this.guiDesktopWidth
        ? 1
        : availableWidth / this.guiDesktopWidth;
      const guiDesktopHeightVisible = this.guiDesktopHeight * guiDesktopScale;

      availableHeight -= guiDesktopHeightVisible;
      this.canvas.style.paddingBottom = `${guiDesktopHeightVisible}px`;
      this.guiDesktop.style.transform = `scale(${guiDesktopScale})`;
    }

    const availableRatio = availableWidth / availableHeight;

    const height = availableRatio > this.aspectRatio ?
      availableHeight : availableWidth / this.aspectRatio;

    this.canvas.style.height = `${height}px`;
  },

  enableFullscreen() {
    const doc = window.document;
    const docEl = doc.documentElement;

    const fullscreenEnabled = doc.fullscreenEnabled || doc.webkitFullscreenEnabled ||
      doc.mozFullScreenEnabled || doc.msFullscreenEnabled;

    if (!fullscreenEnabled) {
      return;
    }

    const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;

    window.addEventListener('touchend', () => {
      const fullscreen = doc.fullscreenElement || doc.mozFullScreenElement ||
        doc.webkitFullscreenElement || doc.msFullscreenElement;

      if (!fullscreen) {
        requestFullScreen.call(docEl);
      }
    });
  },

  enableSafariFullscreen() {
    this.body.classList.add('mobile-safari');

    const hasRules = (el) => {
      if (el.tagName === 'BODY') {
        return false;
      }
      return el.id === 'rules' || hasRules(el.parentNode);
    };

    // запретим ресайз и скрол если не скролятся правила
    window.addEventListener('touchmove', (e) => {
      if (e.touches.length > 1 || (this.minimalUI && !hasRules(e.target))) {
        e.preventDefault();
      }
    });
  },

  bindResize() {
    window.addEventListener('resize', () => {
      this.flag = true;
    });
  },

  preventDoubleTap() {
    let lastTouchEnd = 0;
    window.addEventListener('touchend', (e) => {
      const now = +new Date();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
        e.target.click();
      }
      lastTouchEnd = now;
    });
  },
};

export default resizeManager;



// WEBPACK FOOTER //
// ../base/js/managers/resize.js